import Axhelper from '@/lib/Axhelper'

class InfaktService {
	constructor() {
		this.baseUrl = window.RUNTIME_CONFIG.API_URL
		this.endpoints = {
			searchClient: `${this.baseUrl}/api/infakt/searchclient`,
			addClient: `${this.baseUrl}/api/infakt/addclient`,
			updateClient: `${this.baseUrl}/api/infakt/updateclient`,
		}
	}

	buildClientPayload(clientData = {}) {
		return {
			company_name: clientData.nazwaFirmy || '',
			nip: clientData.nip || '',
			street: clientData.nazwaUlicy || '',
			street_number: clientData.nrBudynku || '',
			flat_number: clientData.nrLokalu || '',
			postal_code: clientData.kodPocztowy || '',
			city: clientData.nazwaMiejscowosci || '',
			email: clientData.adresEmail || '',
		}
	}

	buildClientParams(companyId, clientData = {}, extra = {}) {
		const payload = {
			companyId,
			...this.buildClientPayload(clientData),
			...extra,
		}
		return Object.entries(payload)
			.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value ?? ''))}`)
			.join('&')
	}

	extractClientId(responseData) {
		return (
			responseData?.id ??
			responseData?.entity?.id ??
			responseData?.data?.id ??
			responseData?.client?.id ??
			''
		)
	}

	async searchClient(query, companyId) {
		try {
			const trimmed = (query || '').trim()
			if (!trimmed || !companyId) {
				return { data: [], error: null }
			}

			const url = `${this.endpoints.searchClient}?companyId=${encodeURIComponent(companyId)}&search_query=${encodeURIComponent(trimmed)}`
			const response = await Axhelper.sendGetAsync(url)

			if (response.error) {
				return { data: [], error: response.error }
			}

			return {
				data: Array.isArray(response.data.entities) ? response.data.entities : [],
				error: null,
			}
		} catch (error) {
			console.error('InfaktService.searchClient error:', error)
			return {
				data: [],
				error: error.message || 'Failed to search Infakt clients',
			}
		}
	}

	async addClient(companyId, clientData) {
		try {
			if (!companyId) {
				return { success: false, error: 'Company ID is required.', data: null, id: '' }
			}

			const url = `${this.endpoints.addClient}?${this.buildClientParams(companyId, clientData)}`
			const response = await Axhelper.sendPostAsync(url, {})

			if (response.error) {
				return { success: false, error: response.error, data: null, id: '' }
			}

			return {
				success: true,
				error: null,
				data: response.data || null,
				id: this.extractClientId(response.data),
			}
		} catch (error) {
			console.error('InfaktService.addClient error:', error)
			return {
				success: false,
				error: error.message || 'Failed to add Infakt client',
				data: null,
				id: '',
			}
		}
	}

	async updateClient(companyId, clientId, clientData) {
		try {
			if (!companyId || !clientId) {
				return { success: false, error: 'Company ID and client ID are required.', data: null, id: '' }
			}

			const url = `${this.endpoints.updateClient}/${encodeURIComponent(clientId)}/?${this.buildClientParams(companyId, clientData)}`
			const response = await Axhelper.sendPutAsync(url, {})

			if (response.error) {
				return { success: false, error: response.error, data: null, id: '' }
			}

			return {
				success: true,
				error: null,
				data: response.data || null,
				id: this.extractClientId(response.data) || clientId,
			}
		} catch (error) {
			console.error('InfaktService.updateClient error:', error)
			return {
				success: false,
				error: error.message || 'Failed to update Infakt client',
				data: null,
				id: '',
			}
		}
	}
}

export default new InfaktService()
